module.exports = __webpack_public_path__ + "static/img/07.b27d0c86.png";